import { render, staticRenderFns } from "./page-transform.vue?vue&type=template&id=53c64f4a&scoped=true"
import script from "./page-transform.vue?vue&type=script&lang=js"
export * from "./page-transform.vue?vue&type=script&lang=js"
import style0 from "./page-transform.vue?vue&type=style&index=0&id=53c64f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c64f4a",
  null
  
)

export default component.exports